import { render, staticRenderFns } from "./faqFc.vue?vue&type=template&id=517f156a"
import script from "./faqFc.vue?vue&type=script&lang=js"
export * from "./faqFc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports